import { __extends } from "tslib";
import { RelationType } from './Misc';
var RecursionState = /** @class */ (function () {
    function RecursionState() {
        this.stop = false;
        this.canRecurse = function (model, property) { return !property.noTrack; };
    }
    RecursionState.prototype.pushState = function () {
    };
    RecursionState.prototype.popState = function () {
    };
    /**
     * Overwrites the canRecurse callback to always return true.
     */
    RecursionState.prototype.includeNonTrackedProperties = function () {
        this.canRecurse = function (model, property) { return true; };
        return this;
    };
    return RecursionState;
}());
export { RecursionState };
var BooleanRecursionState = /** @class */ (function (_super) {
    __extends(BooleanRecursionState, _super);
    function BooleanRecursionState(flag) {
        if (flag === void 0) { flag = false; }
        var _this = _super.call(this) || this;
        _this.flag = flag;
        return _this;
    }
    return BooleanRecursionState;
}(RecursionState));
export { BooleanRecursionState };
export function traverseItems(model, stateOrCallback, callbackOrListCallback, listCallback) {
    var state;
    var callback;
    if (typeof stateOrCallback === "function") {
        state = new RecursionState();
        callback = stateOrCallback;
        listCallback = callbackOrListCallback;
    }
    else {
        state = stateOrCallback;
        callback = callbackOrListCallback;
    }
    if (model instanceof Array) {
        return invokeOnItemsAndChildren(model, state, callback, listCallback, undefined);
    }
    else {
        return invokeOnSelfAndChildren(model, state, callback, listCallback, undefined);
    }
}
function invokeOnItemsAndChildren(list, state, callback, listCallback, relationType) {
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var item = list_1[_i];
        invokeOnSelfAndChildren(item, state, callback, listCallback, relationType);
        if (state.stop)
            break;
    }
    return state;
}
function invokeOnSelfAndChildren(model, state, callback, listCallback, relationType) {
    callback(model, state, relationType);
    if (state.stop)
        return state;
    var ctor = model.constructor;
    if (ctor.neo.children) {
        for (var i = 0; i < ctor.neo.children.length; i++) {
            var cpi = ctor.neo.children[i];
            if (state.canRecurse(model, cpi)) {
                if (cpi.relationType == RelationType.ChildList) {
                    // @ts-ignore
                    var childList = model[cpi.propertyName];
                    if (listCallback)
                        listCallback(childList, state);
                    if (state.stop)
                        return state;
                    state.pushState();
                    invokeOnItemsAndChildren(childList, state, callback, listCallback, RelationType.ChildList);
                    state.popState();
                    if (state.stop)
                        return state;
                }
                else {
                    try {
                        // @ts-ignore
                        var child = model[cpi.propertyName];
                        if (child) {
                            state.pushState();
                            invokeOnSelfAndChildren(child, state, callback, listCallback, cpi.relationType);
                            state.popState();
                        }
                    }
                    catch (error) {
                        throw "Error on property '".concat(cpi.propertyName, "' on type '").concat(model.constructor.name, "': ").concat(error);
                    }
                }
            }
        }
    }
    return state;
}
